//////// GHG 2.4 EA
const twoFourSchema = {
  title: "2.4 Indirect Emissions from Purchased/Acquired Cooling",
  addAPI: "cat2_2AddEmissionActivityAPI",
  cat: "cat2_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Energy Supplier or Region",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Energy Type",
      optionsAPI: "ghg2_4ActivityDropdown",
      required: true,
    },
  ],
};

export default twoFourSchema;
